export const VERIFICATION_STATUS = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  UNDER_REVIEW: "UNDER_REVIEW",
};

export const PERSON_STATUS = {
  VERIFIED: "verified",
  PENDING: "pending",
};

const normalizeVerificationStatus = (status) => String(status || "").toUpperCase();

/** Normalize person KYC status; APPROVED maps to `verified`. */
export const normalizePersonStatus = (status) => {
  const normalized = String(status || "").trim().toLowerCase();
  if (normalized === "approved") return PERSON_STATUS.VERIFIED;
  return normalized;
};

export const isVerificationStatusApproved = (status) =>
  normalizeVerificationStatus(status) === VERIFICATION_STATUS.APPROVED;

export const isVerificationStatusPending = (status) => {
  const normalized = normalizeVerificationStatus(status);
  return (
    normalized === VERIFICATION_STATUS.PENDING
    || normalized === VERIFICATION_STATUS.UNDER_REVIEW
    || normalized === VERIFICATION_STATUS.REJECTED
  );
};

/**
 * Resolve person status for Conta Individualizada banner.
 * Prefer explicit person_status / status from /v1/ib/accounts/me.
 */
export const resolvePersonStatus = ({
  personStatus,
  status,
  verificationStatus,
  documentPending,
  pending,
  individualAccountStatus,
} = {}) => {
  const explicit = normalizePersonStatus(personStatus || status);
  if (explicit) return explicit;

  if (isVerificationStatusApproved(verificationStatus)) return PERSON_STATUS.VERIFIED;
  if (individualAccountStatus === "active") return PERSON_STATUS.VERIFIED;

  if (documentPending === true || pending === true) return PERSON_STATUS.PENDING;
  if (isVerificationStatusPending(verificationStatus)) return PERSON_STATUS.PENDING;

  // /me with document_pending === false → verified (classic IB complete).
  if (documentPending === false || pending === false) return PERSON_STATUS.VERIFIED;

  return "";
};

/** Exact banner gate: show only when person status !== `verified`. */
export const isPersonStatusVerified = (status) =>
  normalizePersonStatus(status) === PERSON_STATUS.VERIFIED;

/**
 * @deprecated Prefer resolvePersonStatus + isPersonStatusVerified.
 * Kept for callers that still pass document/KYC flags.
 */
export const isPersonVerified = ({
  documentPending,
  pending,
  personStatus,
  status,
  verificationStatus,
  individualAccountStatus,
} = {}) =>
  isPersonStatusVerified(
    resolvePersonStatus({
      personStatus,
      status,
      verificationStatus,
      documentPending,
      pending,
      individualAccountStatus,
    }),
  );

/**
 * Whether the Conta Individualizada promo should show.
 * Condition: person status !== `verified`.
 */
export const isAccountKycPending = (flags = {}) =>
  !isPersonStatusVerified(resolvePersonStatus(flags));
